const state = {
  size: 0,
  isMobile: false,
  isPortrait: false,
  isWebView: false,
  countryCode: 'US',
  language: 'en'
}

const getters = {}

const actions = {
  track({ commit }) {
    commit('SET_WINDOW_SIZE', window.innerWidth)

    window.addEventListener('resize', () => {
      commit('SET_WINDOW_SIZE', window.innerWidth)
    })
  }
}

const mutations = {
  SET_WINDOW_SIZE(state, width) {
    state.size = width
    state.isMobile = width <= 1024
    state.isPortrait = width <= 768
  },
  SET_WEB_VIEW(state, isWebView) {
    state.isWebView = isWebView
  },
  SET_COUNTRY_CODE(state, countryCode) {
    state.countryCode = countryCode
  },
  SET_LANGUAGE(state, language) {
    state.language = language
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
